import Image from '../../components/Image';
import useEnv from '../../hooks/useEnv';

type Props = {
  className?: string;
};

const PromotionalBanner = ({ className }: Props) => {
  const { FF_PLP_PROMO_BANNER } = useEnv();

  if (!FF_PLP_PROMO_BANNER) return null;

  return (
    <div className={`flex justify-center ${className ?? ''}`}>
      <Image
        alt="subscription-banner"
        src="https://cms-cdn.thesolesupplier.co.uk/banners/may_1_marketplace_hub_mobile.png"
        responsiveOptions={{
          md: {
            src: 'https://cms-cdn.thesolesupplier.co.uk/banners/may_1_marketplace_hub_desktop.png'
          }
        }}
        quality={100}
      />
    </div>
  );
};

export default PromotionalBanner;
